import { ArrowRight, AlertCircle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@/components/atoms/new-button';

const NoAnswer = () => {
  const [_, setSearchParams] = useSearchParams();

  const onNewSearchClick = () => {
    setSearchParams((prev) => {
      prev.delete('threadId');
      return prev;
    });
  };

  return (
    <div className="flex w-full items-center justify-center p-6">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-lg">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
            <AlertCircle className="h-5 w-5 text-gray-500" />
          </div>

          <h3 className="mb-2 text-base font-medium text-gray-700">Unable to process answer</h3>

          <p className="mb-6 text-sm leading-relaxed text-gray-500">
            We couldn't process your request. Please try again.
          </p>

          <Button variant="brand" size="default" onClick={onNewSearchClick} className="gap-2">
            Try again
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoAnswer;
